var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWhiteBrochureIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "white-brochure-icon_svg__a",
    d: "M0 0h20.293v16.234H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "white-brochure-icon_svg__c",
    d: "M0 0h5.19v5.162H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "white-brochure-icon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#white-brochure-icon_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.386 13.887a.483.483 0 01-.223.412c-.147.107-.296.127-.443.064-1.564-.592-3.668-.952-6.31-1.079A.977.977 0 011.776 13a.86.86 0 01-.254-.633V2.441c0-.254.095-.47.286-.65a.944.944 0 01.666-.269c.634 0 1.479.084 2.536.253 1.522.232 2.779.571 3.773 1.014.169.085.312.212.428.381.116.17.175.36.175.571v10.146zm7.735-.559c-2.641.127-3.983.443-5.547 1.035-.148.063-.296.043-.444-.064a.485.485 0 01-.223-.412V3.741c0-.21.059-.402.175-.57.116-.17.259-.297.428-.382.994-.443 2.25-.782 3.773-1.014 1.057-.169 1.903-.253 2.537-.253.254 0 .475.09.666.268.19.18.286.397.286.651l-.008 8.59c.023-.126 0-.015 0 0l1.52.487c.009-.152.009.063.009-.152V2.441c0-.677-.243-1.252-.73-1.728A2.412 2.412 0 0017.82 0c-.338 0-.856.042-1.554.127a20.928 20.928 0 00-3.012.507c-1.247.296-2.283.688-3.107 1.174C9.323 1.321 8.286.93 7.039.633A20.89 20.89 0 004.028.126C3.328.041 2.812 0 2.474 0 1.797 0 1.216.24.73.713A2.325 2.325 0 000 2.441v9.925c0 .655.228 1.214.682 1.68.454.465 1.01.72 1.665.761.93.042 1.828.138 2.695.285 1.353.212 2.442.518 3.266.92.254.147.528.222.824.222h2.029c.296 0 .57-.075.825-.222.824-.402 1.913-.708 3.265-.92.867-.147 1.41-.28 2.34-.322l-.47-1.442z",
    fill: "#FFF",
    mask: "url(#white-brochure-icon_svg__b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.374 12.518)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "white-brochure-icon_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#white-brochure-icon_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.746 2.731l.982-.564a.23.23 0 00-.03-.414L.317.016a.234.234 0 00-.25.051.228.228 0 00-.05.248l1.747 4.356a.233.233 0 00.416.031l.567-.978 1.377 1.37a.232.232 0 00.327 0l.672-.669a.228.228 0 000-.325L3.746 2.731z",
    fill: "#FFF",
    mask: "url(#white-brochure-icon_svg__d)"
  })))));
}

export default SvgWhiteBrochureIcon;